import React from "react";
import { Skeleton } from "components/ui";

export function ActivityDetailSkeleton() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 divide-y lg:divide-y-0 lg:divide-x divide-gray-200 dark:divide-dark-600">
      {/* Left Section - Calendar/Core Info Skeleton */}
      <div className="p-4 sm:p-5 space-y-4">
        {/* Activity Name */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-28 rounded bg-gray-200 dark:bg-dark-600" />
          <Skeleton className="h-10 w-full rounded bg-gray-150 dark:bg-dark-650" />
        </div>

        {/* Lead Selection */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-16 rounded bg-gray-200 dark:bg-dark-600" />
          <Skeleton className="h-10 w-full rounded bg-gray-150 dark:bg-dark-650" />
        </div>

        {/* Activity Date */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-24 rounded bg-gray-200 dark:bg-dark-600" />
          <Skeleton className="h-10 w-full rounded bg-gray-150 dark:bg-dark-650" />
        </div>

        {/* Time Selection */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-16 rounded bg-gray-200 dark:bg-dark-600" />
          <Skeleton className="h-10 w-full rounded bg-gray-150 dark:bg-dark-650" />
        </div>

        {/* Remind Me / Assignee */}
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <Skeleton className="h-4 w-20 rounded bg-gray-200 dark:bg-dark-600" />
            <Skeleton className="h-10 w-full rounded bg-gray-150 dark:bg-dark-650" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-4 w-24 rounded bg-gray-200 dark:bg-dark-600" />
            <Skeleton className="h-10 w-full rounded bg-gray-150 dark:bg-dark-650" />
          </div>
        </div>

        {/* Status */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-16 rounded bg-gray-200 dark:bg-dark-600" />
          <Skeleton className="h-10 w-full rounded bg-gray-150 dark:bg-dark-650" />
        </div>
      </div>

      {/* Right Section - Details/Composer Skeleton */}
      <div className="col-span-2 lg:col-span-2 p-4 sm:p-6 space-y-6">
        {/* Section Header */}
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-32 rounded bg-gray-200 dark:bg-dark-600" />
          <Skeleton className="h-5 w-40 rounded bg-gray-200 dark:bg-dark-600" />
        </div>

        {/* Composer Card Skeleton */}
        <div className="border border-gray-150 dark:border-dark-600 rounded-xl p-5 space-y-4">
          <div className="space-y-2">
            <Skeleton className="h-4 w-28 rounded bg-gray-200 dark:bg-dark-600" />
            <Skeleton className="h-10 w-full rounded bg-gray-150 dark:bg-dark-650" />
          </div>

          <div className="space-y-2">
            <Skeleton className="h-4 w-20 rounded bg-gray-200 dark:bg-dark-600" />
            <Skeleton className="h-10 w-full rounded bg-gray-150 dark:bg-dark-650" />
          </div>
        </div>

        {/* Detailed Notes Skeleton */}
        <div className="space-y-2">
          <Skeleton className="h-4 w-36 rounded bg-gray-200 dark:bg-dark-600" />
          <div className="border border-gray-150 dark:border-dark-600 rounded-xl overflow-hidden">
            {/* Rich Text Editor Toolbar mimic */}
            <div className="bg-gray-50 dark:bg-dark-800 border-b border-gray-150 dark:border-dark-600 p-2 flex gap-2">
              <Skeleton className="h-6 w-8 rounded bg-gray-200 dark:bg-dark-600" />
              <Skeleton className="h-6 w-8 rounded bg-gray-200 dark:bg-dark-600" />
              <Skeleton className="h-6 w-8 rounded bg-gray-200 dark:bg-dark-600" />
              <div className="w-px h-6 bg-gray-300 dark:bg-dark-600 mx-1" />
              <Skeleton className="h-6 w-6 rounded bg-gray-200 dark:bg-dark-600" />
              <Skeleton className="h-6 w-6 rounded bg-gray-200 dark:bg-dark-600" />
              <Skeleton className="h-6 w-6 rounded bg-gray-200 dark:bg-dark-600" />
              <div className="w-px h-6 bg-gray-300 dark:bg-dark-600 mx-1" />
              <Skeleton className="h-6 w-16 rounded bg-gray-200 dark:bg-dark-600" />
            </div>
            {/* Editor Area mimic */}
            <div className="p-4 space-y-3">
              <Skeleton className="h-4 w-3/4 rounded bg-gray-150 dark:bg-dark-650" />
              <Skeleton className="h-4 w-1/2 rounded bg-gray-150 dark:bg-dark-650" />
              <Skeleton className="h-4 w-5/6 rounded bg-gray-150 dark:bg-dark-650" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActivityDetailSkeleton;
